import request from '@/utils/request'
import api from '@/api/api'
export class User {
  register(data) {
    return request({
      url: api.user.register,
      method: 'post',
      data
    })
  }
  sendVerifiCode(data) {
    return request({
      url: api.user.sendVerifiCode,
      method: 'post',
      data
    })
  }
  forgotPassWordCode(data) {
    return request({
      url: api.user.forgotPassWordCode,
      method: 'post',
      data
    })
  }
  checkResetCode(data) {
    return request({
      url: api.user.checkResetCode,
      method: 'post',
      data
    })
  }
  resetPassword(data) {
    return request({
      url: api.user.resetPassword,
      method: 'post',
      data
    })
  }

  logIn(data) {
    return request({
      url: api.user.login,
      method: 'post',
      data
    })
  }
  logout() {
    return request({
      url: api.user.logout,
      method: 'get'
    })
  }
}
